import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';
import * as React from 'react';

import { Gradients } from '@/shared/components/theme/gradient';
import { cn } from '@/shared/utils/cn';

const RadioGroup = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Root
      className={cn('grid gap-2', className)}
      {...props}
      ref={ref}
    />
  );
});
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName;

const RadioGroupItem = React.forwardRef<
  React.ElementRef<typeof RadioGroupPrimitive.Item>,
  React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>
>(({ className, ...props }, ref) => {
  return (
    <RadioGroupPrimitive.Item
      ref={ref}
      className={cn(
        'relative aspect-square h-5 w-5 rounded-full border-0 shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <div className="absolute inset-0 h-5 w-5 rounded-full bg-white/50" />
      <div className="absolute inset-0.5 h-4 w-4 rounded-full border border-black" />
      <div className="absolute inset-1 h-3 w-3 rounded-full bg-white/50" />
      <RadioGroupPrimitive.Indicator
        className={cn(
          'absolute inset-1 h-3 w-3 rounded-full',
          Gradients.greenGradient,
        )}
      />
    </RadioGroupPrimitive.Item>
  );
});
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName;

export { RadioGroup, RadioGroupItem };
